import { simpleOrganizationFragment } from './fragmentsOrganization';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const organizationUpdateMutationAtom = createMutationAtomFactory(
  'admin.organizationUpdate',
  (params: {
    id: string;
    name?: string;
    domain?: string;
    timezone?: string;
    idpId?: string;
  }) => ({
    coreOrganizationUpdate: {
      __args: {
        id: params.id,
        input: {
          name: params.name,
          domain: params.domain,
          timezone: params.timezone,
          idpId: params.idpId,
        },
      },
      ...simpleOrganizationFragment,
    },
  }),
);
